import { Tween } from "@westpierstudio/luma/createjs";
import { Action } from "@westpierstudio/luma/utils/flow/Action";

export class MinTimeBetweenWagersAction extends Action {
    private startTime: number;

    constructor(private readonly minTimeBetweenWagers: number, private readonly log = false) {
        super();
        this.startTime = Date.now();
    }

    run(): void {

        const elapsedTime = Date.now() - this.startTime;

        if (elapsedTime >= this.minTimeBetweenWagers) {

            if (this.log) {
                console.log(`minTimeBetweenWagers (${this.minTimeBetweenWagers}ms) already elapsed`);
            }

            this.complete();

        } else {
            const remaining = this.minTimeBetweenWagers - elapsedTime;

            Tween.get(this)
                .wait(remaining)
                .call(() => this.complete());

            if (this.log) {
                console.log(`minTimeBetweenWagers delay - elapsedTime ${elapsedTime}ms - wait ${remaining}ms - total ${this.minTimeBetweenWagers}ms`);
            }
        }
    }

    destroy(): void {
        Tween.removeTweens(this);
    }

    override toString() {
        return `DelayAction ${this.minTimeBetweenWagers}ms`;
    }
}